import { render } from "./CategoriesTab.vue?vue&type=template&id=329c2b8a&ts=true"
import script from "./CategoriesTab.vue?vue&type=script&lang=ts"
export * from "./CategoriesTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__